import axios from 'axios';

export function updateLegalDocument(token, payload) {
    return axios.put(`${process.env.REACT_APP_API_URL}/admin/legalDocuments`, payload, {
        headers: {
            Authorization: `${token}`
        }
    });
}
